import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";

const DialogPopup = ({ open, onClose, onConfirm, selectItem,  title, message }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            aria-labelledby="dialog-title"
        >
            <DialogTitle style={{ padding: 0 }}>
                <div
                    style={{
                        borderBottom: "1px solid #e0e0e0",
                        width: "100%",
                        padding: "8px 12px",
                    }}
                >
                    <span style={{ fontSize: "18px" }}>{title}</span>
                </div>
            </DialogTitle>
            <DialogContent>
                <div className="flexRow" style={{ padding: "10px 0" }}>
                    <span className="smallTxt" style={{ color: "#909090" }}>
                        {message}
                    </span>
                </div>
            </DialogContent>
            <DialogActions>
                <div className="flexRow justfiyEnd alignEnd">
                    <Button
                        color="primary"
                        style={{ textTransform: "capitalize" }}
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        color="primary"
                        style={{ textTransform: "capitalize", marginLeft: "8px" }}
                        onClick={() => onConfirm(selectItem.id, selectItem.documentId)}
                    >
                        Accept
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
};

export default DialogPopup;